/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_New_LabelInputs */

const en_jobs_new_label = /** @type {(inputs: Jobs_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEW`)
};

const de_jobs_new_label = /** @type {(inputs: Jobs_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEU`)
};

const fr_jobs_new_label = /** @type {(inputs: Jobs_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NOUVEAU`)
};

const es_jobs_new_label = /** @type {(inputs: Jobs_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NUEVO`)
};

const it_jobs_new_label = /** @type {(inputs: Jobs_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NUOVO`)
};

const nl_jobs_new_label = /** @type {(inputs: Jobs_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NIEUW`)
};

const pl_jobs_new_label = /** @type {(inputs: Jobs_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NOWE`)
};

const fi_jobs_new_label = /** @type {(inputs: Jobs_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUSI`)
};

const da_jobs_new_label = /** @type {(inputs: Jobs_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NY`)
};

const sv_jobs_new_label = /** @type {(inputs: Jobs_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NY`)
};

/**
* | output |
* | --- |
* | "NEW" |
*
* @param {Jobs_New_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_new_label = /** @type {((inputs?: Jobs_New_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_New_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_new_label(inputs)
	if (locale === "fr") return fr_jobs_new_label(inputs)
	if (locale === "es") return es_jobs_new_label(inputs)
	if (locale === "it") return it_jobs_new_label(inputs)
	if (locale === "nl") return nl_jobs_new_label(inputs)
	if (locale === "pl") return pl_jobs_new_label(inputs)
	if (locale === "fi") return fi_jobs_new_label(inputs)
	if (locale === "da") return da_jobs_new_label(inputs)
	if (locale === "sv") return sv_jobs_new_label(inputs)
	return en_jobs_new_label(inputs)
});